import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import style from './style.js'

const BetaLabel = ({ classes }) => {
  return (
    <div className={classes.betaLabel}>
      <span>Beta</span>
    </div>
  )
}

export default withStyles(style)(BetaLabel)
